<template>
  <div class="container" :style="data && (data.group_order)
    ? `box-shadow: inset 0px 0px 0px 2px ${stringToColour(
      data.id + '|' + data.pick_up_location_details
        ? data.pick_up_location_details
        : data.landmark_pickup
          ? data.landmark_pickup
          : data.pick_up_location_name
    )};`
    : ''
    ">
    <div class="content" v-if="this.data">
      <!-- This code creates a div that displays information about a booking -->
      <div class="title">
        <div class="info">
          <!-- This line displays the passenger's full name -->
          <p class="order-id">
            {{ data.passenger ? data.passenger.full_name : "" }}
            <!-- This line displays the booking ID -->
            <span :style="{
              color: data.high_priority == 1 ? 'rgb(239 194 11)' : '#e10015',
              fontWeight: 'bold',
              border: data.high_priority == 1 ? '1px solid rgb(239 194 11)' : '1px solid #e10015',
              padding: '3px'
            }">{{ data.id }}</span>
            <!-- This line displays the group order number if it exists -->
            <span style="color: #788e98; float: right" v-if="data.group_order">
              {{ data.group_order }}</span>

            <!-- <span style="color: #788e98; float: right" v-if="data.hasRedispatchLog == 1">
              {{ '1/2' }}</span
            >
            <span style="color: #788e98; float: right" v-if="data.hasRedispatchLog == 2">
              {{ '2/2' }}</span
            > -->
            <!-- This line displays a mobile icon if the booking from customer app -->
            <span style="color: #788e98; float: right; position: absolute; top: 0; right: 0"
              v-if="data.origin === 'app'">
              <v-icon style="color: #d71010"> fa fa-mobile </v-icon>
            </span>
            <!-- This line displays a laptop icon sif the booking from call center -->
            <span style="color: #788e98; float: right; position: absolute; top: 0; right: 0"
              v-else-if="data.origin === 'dashboard'">
              <v-icon style="color: #d71010"> fa fa-laptop </v-icon>
            </span>
            <!-- This line displays a phone icon if the booking from customer dashboard -->
            <span style="color: #788e98; float: right; position: absolute; top: 0; right: 0"
              v-else-if="data.origin === 'phone'">
              <v-icon style="color: #d71010"> fa fa-phone </v-icon>
            </span>
          </p>
        </div>
      </div>
      <div class="constraints" v-if="constraints.length">
        {{ $t("dispatching.orderCard.constraints") }}
        <span v-for="(constraint, index) in constraints" :key="index" style="display: inline-block">
          <span v-if="constraint.icon">
            <img :title="constraint.title" :src="require(`@/assets/constraints/${constraint.icon}.svg`)" width="18"
              style="margin-right: 5px" /></span>
          <span v-else :class="[constraint.strike_through ? 'strike_through' : '']"> {{ constraint.title }} </span>
          <span v-if="index !== constraints.length - 1">/&nbsp;</span>
        </span>
      </div>
      <p v-if="data.status === 'PAID'" style="color: green"><b>{{ $t("dispatching.orderCard.completed") }}</b></p>
      <p v-else-if="data.status === 'PAX_CANCELLED'" style="color: red; display: flex; align-items: center; gap: 5px;">
        <b>{{ $t("dispatching.orderCard.cancelledByCustomer") }}</b>
        <v-tooltip v-if="data.passenger_cancellation_reason" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" small style="cursor: pointer; color: #788e98;">fa fa-info-circle</v-icon>
          </template>
          <span style="font-family: Poppins; font-size: 14px;">{{ data.passenger_cancellation_reason }}</span>
        </v-tooltip>
      </p>
      <p v-else-if="data.status === 'CAPTAIN_CANCELLED'" style="color: red; display: flex; align-items: center; gap: 5px;">
        <b>{{ $t("dispatching.orderCard.cancelledByDriver") }}</b>
        <v-tooltip v-if="data.captain_cancellation_reason" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" small style="cursor: pointer; color: #788e98;">fa fa-info-circle</v-icon>
          </template>
          <span style="font-family: Poppins; font-size: 14px;">{{ data.captain_cancellation_reason }}</span>
        </v-tooltip>
      </p>
      <p v-else-if="(data.status === 'SYSTEM_CANCELLED' || data.status === 'REJECTED') && !data.system_cancellation_reason" style="color: red; display: flex; align-items: center; gap: 5px;">
        <b>{{ $t("dispatching.orderCard.cancelledByCC") }}</b>
        <v-tooltip v-if="data.user_cancellation_reason" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" small style="cursor: pointer; color: #788e98;">fa fa-info-circle</v-icon>
          </template>
          <span style="font-family: Poppins; font-size: 14px;">{{ data.user_cancellation_reason }}</span>
        </v-tooltip>
      </p>
      <p v-else-if="(data.status === 'SYSTEM_CANCELLED' || data.status === 'REJECTED') && data.system_cancellation_reason" style="color: red; display: flex; align-items: center; gap: 5px;">
        <b>{{ $t("dispatching.orderCard.cancelledBySystem") }}</b>
        <v-tooltip v-if="data.system_cancellation_reason" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" small style="cursor: pointer; color: #788e98;">fa fa-info-circle</v-icon>
          </template>
          <span style="font-family: Poppins; font-size: 14px;">{{ data.system_cancellation_reason }}</span>
        </v-tooltip>
      </p>
      <p v-else-if="show_status">
        {{ this.orderStatuses[data.status] }}
      </p>
     
      <div v-if="
        data.captain_first_name || data.captain_name || (data.ride && data.ride.captain)
      " class="w-full float-left">
        <div class="driver">
          <div class="captain-profile-pic">
            #<span v-if="data.taxi_number">{{ data.taxi_number }}</span>
            <span v-else-if="data.ride">{{ data.ride.captain.username }}</span>
          </div>
          <label>
            {{ $t("dispatching.orderCard.driver") }}
            <span v-if="data.captain_first_name">{{ data.captain_first_name }}</span>
            <span v-else-if="data.ride">{{
              `${data.ride.captain.first_name} ${data.ride.captain.last_name}`
            }}</span>
            <span v-else-if="data.captain_name">{{ data.captain_name }}</span>
          </label>
        </div>
      </div>
      <div class="locations">
        <div class="location">
          <div class="circle" style="background-color: #fff"></div>
          <label class="location">
            <label style="color: #00abb3">{{ data.pick_up_location_name }}, </label>
            <label>{{
              data.pick_up_location_details
                ? data.pick_up_location_details
                : data.landmark_pickup
                  ? data.landmark_pickup
                  : data.pick_up_location_name
            }}</label>
          </label>
        </div>
        <div class="location">
          <div class="circle"></div>
          <label>{{
            data.pull_down_location_details
              ? data.pull_down_location_details
              : data.landmark_dropoff
                ? data.landmark_dropoff
                : data.pull_down_location_name
          }}</label>
        </div>
      </div>
      <p class="datetime" v-if="data.room_number">
        <span>{{ $t("dispatching.orderCard.roomNumber", { number: data.room_number }) }}</span>
      </p>
      <p v-if="data.transformed">
        <b>{{ $t("dispatching.orderCard.transformed") }} </b>
      </p>
      <p class="datetime"
        v-if="(data.car_brand_model) || (data.ride && data.ride.car && data.ride.car.brand_model.brand.name)">
        <span v-if="data.car_brand_model && data.car_brand">{{ $t("dispatching.orderCard.car", { brand: data.car_brand, model: data.car_brand_model, color: data.car_color }) }}</span>
        <span v-else>{{ $t("dispatching.orderCard.car", { brand: data.ride.car.brand_model.brand.name, model: data.ride.car.brand_model.name, color: data.ride.car.color.name }) }}</span>
      </p>
      <p class="datetime" v-if="(data.car_plate_number) || (data.ride && data.ride.car)">
        <span v-if="data.car_plate_number">{{ $t("dispatching.orderCard.plateNumber", { number: data.car_plate_number }) }}</span>
        <span v-else>{{ $t("dispatching.orderCard.plateNumber", { number: data.ride.car.number }) }}</span>
      </p>
      <!-- <p
        class="datetime"
        v-if="	
            data.ride && data.ride.car && data.ride.car.brand_model.brand.name
        "
      >
        <span
          >Car: {{ data.ride.car.brand_model.brand.name }} ,
          {{ data.ride.car.brand_model.name }},
          {{ data.ride.car.color.name }}</span
        >
      </p> -->
      <p class="datetime" v-if="this.data.passenger">
        <span>{{ $t("dispatching.orderCard.phoneNumber", {
          phone: !this.validateEmail(data.passenger.username)
              ? data.passenger.username
              : data.passenger.phone_number || data.passenger.phone
          }) }}</span>
      </p>
      <p style="display: flex; flex-direction: row; gap: 4px; align-items: center" class="datetime">
        <img :src="require(`@/assets/constraints/person.svg`)" />
        <span> {{ this.data.seats > 1 ? $t("dispatching.orderCard.passengers", { count: data.seats }) : $t("dispatching.orderCard.passenger", { count: data.seats }) }} </span>
      </p>

      <p class="datetime">
        <span>{{ $t("dispatching.orderCard.vehicle", { type: data.vehicle_type }) }}</span>
      </p>

      <p class="datetime" v-if="data.notes">
        <span>{{ $t("dispatching.orderCard.comment", { notes: data.notes }) }}</span>
      </p>
      <p class="datetime">
        <span v-if="payment != 0">{{ $t("dispatching.orderCard.paidAmount", { amount: payment }) }}€</span> <span v-if="payment != 0 && tip != 0"> /
        </span><span v-if="tip != 0"> {{ $t("dispatching.orderCard.tip", { amount: tip }) }}€</span>
      </p>
      <p class="datetime" v-if="cancellation_fee != 0">
        <span>{{ $t("dispatching.orderCard.cancellationFee", { amount: cancellation_fee }) }}€</span>
      </p>
      <p class="datetime" v-if="(data.min_price && data.max_price) || (data.meta && data.meta.min_price && data.meta.max_price)">
        <span>{{ $t("dispatching.orderCard.estimatedPrice") }} </span>
        <span>{{ data.min_price || data.meta.min_price }}</span>
        <span> - </span>
        <span>{{  data.max_price || data.meta.max_price }} €</span>
      </p>
      <p class="datetime">
        <span>{{ $t("dispatching.orderCard.createdAt", { date: formatters.datetime(data.created_at) }) }}</span>
      </p>
      <p class="datetime" v-if="data.origin === 'phone' && data.user_first_name !== null">
        <span>{{ $t("dispatching.orderCard.createdBy", { name: data.user_first_name }) }}</span>
      </p>
      <p class="datetime" v-if="data.creator_email !== null">
        <span>{{ $t("dispatching.orderCard.creatorEmail", { email: data.creator_email }) }}</span>
      </p>
      <p class="datetime" v-if="data.meta && data.meta.captain_order">
        <span>{{ $t("dispatching.orderCard.captainOrder", { order: data.meta.captain_order }) }}</span>
      </p>
      <p class="datetime">
        <span>{{ formateDateTime(data.datetime) }}</span>
      </p>
      <order-actions v-if="!hideActions" :data="data" @cancelled="(id) => $emit('cancelled', id)">
        <!-- <p v-if="!moment(data.besoin_date).isAfter(moment())"> -->
        <p style="margin-left: auto" v-if="moment(data.besoin_date).isAfter(moment()) && test"
          :class="{ timer: red }">
          {{ ((Math.floor(diff / 60) % 60) + "").padStart(2, "0") }}:{{
            (Math.round(diff % 60) + "").padStart(2, "0")
          }}
        </p>
      </order-actions>
    </div>
    <div v-else>{{ $t("common.loading") }}</div>
  </div>
</template>

<script>
import moment from "moment";
import OrderActions from "@/components/dispatching/OrderActions";

export default {
  name: "OrderCard",
  components: {
    OrderActions,
  },
  props: {
    data: {
      type: Object,
      required: false,
    },
    id: {
      type: Number,
      required: false,
    },
    hideActions: {
      type: Boolean,
      required: false,
      default: false,
    },
    besoin: {
      type: Number,
      required: false,
      default: 0,
    },
    show_status: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      constraints: [],
      payment: 0,
      tip: 0,
      cancellation_fee: 0,
      pickup: "Sass Café, Avenue Prinscesse Grace",
      destination: "Monaco",
      showPastTime: true,
      date: "",
      test: "",
      diff: "",
      red: false,
      formatters: {
        datetime(value) {
          return moment(value).format("HH[h]m - DD/MM/YYYY");
        },
        created_at(value) {
          return moment(value).format("HH[h]m - DD/MM/YYYY");
        },
      },
    };
  },

  computed: {
    time: function () {
      return moment(this.date);
    },
    orderStatuses() {
      return {
        PENDING: this.$t("dispatching.orderCard.statuses.PENDING"),
        APPROVED: this.$t("dispatching.orderCard.statuses.APPROVED"),
        ACCEPTED: this.$t("dispatching.orderCard.statuses.ACCEPTED"),
        STARTED: this.$t("dispatching.orderCard.statuses.STARTED"),
        ARRIVED: this.$t("dispatching.orderCard.statuses.ARRIVED"),
        PICKED_UP: this.$t("dispatching.orderCard.statuses.PICKED_UP"),
        DONE: this.$t("dispatching.orderCard.statuses.DONE"),
        PAID: this.$t("dispatching.orderCard.statuses.PAID"),
        DELETED: this.$t("dispatching.orderCard.statuses.DELETED"),
        CAPTAIN_CANCELLED: this.$t("dispatching.orderCard.statuses.CAPTAIN_CANCELLED"),
        PAX_CANCELLED: this.$t("dispatching.orderCard.statuses.PAX_CANCELLED"),
        SYSTEM_CANCELLED: this.$t("dispatching.orderCard.statuses.SYSTEM_CANCELLED"),
        REJECTED: this.$t("dispatching.orderCard.statuses.REJECTED"),
      };
    },
  },
  watch: {
    diff() {
      this.test = this.diff;
      if (this.diff < 600) {
        this.red = true;
      }
    },
    // besoin: function () {
    //   if (this.data.id == this.besoin) {
    //     console.log("watched");
    //     console.log(this.besoin);
    //     this.actions.push({
    //       img: "renew.svg",
    //       hint: "Extend order TTL",
    //       method: "extendOrder",
    //     });
    //   }
    // },
  },
  mounted: function () {
    if (this.diff)
      setInterval(() => {
        this.diff--;
      }, 1000);
  },
  created() {
    if (this.data) {
      var now = moment();
      if (this.data.besoin_date) {
        var time = moment(this.data.besoin_date).format("YYYY-MM-DD HH:mm:ss");
        this.diff = moment(time, "YYYY-MM-DD HH:mm:ss").diff(
          moment(now, "YYYY-MM-DD HH:mm:ss")
        );
        var duration = moment.duration(now.diff(time));
        var minutes = duration.asSeconds();
        this.diff = minutes < 0 ? minutes * -1 : minutes;
        console.log(minutes);
      }
      this.showPastTime = ["PENDING", "APPROVED", "ACCEPTED"].includes(this.data.status);
      // if (this.data.seats) {
      //   this.constraints.push({
      //     title: `${this.data.seats} Passenger${
      //       this.data.seats > 1 ? "s" : ""
      //     }`,
      //     icon: "person",
      //   });
      // }
      // if (this.data.high_priority) {
      //   this.constraints.push({
      //     title: "VIP",
      //     icon: "vip",
      //   });
      // }

      if (this.data.static_constraints && this.data.static_constraints.length != 0) {
        for (let i = 0; i < this.data.static_constraints.length; i++) {
          if (this.data.static_constraints[i].constraint_name == "encompt") {
            this.constraints.push({
              title: this.data.static_constraints[i].constraint_name,
              icon: "en_compt",
              strike_through: 0
            });
          } else {
            this.constraints.push({
              title: this.data.static_constraints[i].constraint_name,
              icon: false,
              strike_through: 0
            });
          }
        }
      }
      if (this.data.payments && this.data.payments.length != 0) {
        for (let i = 0; i < this.data.payments.length; i++) {
          if (this.data.payments[i].status == "DONE" && this.data.payments[i].type == "booking") {
            this.payment += this.data.payments[i].amount;
          } else if (this.data.payments[i].status == "DONE" && this.data.payments[i].type == "tip") {
            this.tip += this.data.payments[i].amount;
          } else if (this.data.payments[i].status == "DONE" && this.data.payments[i].type == "CANCELLATION_FEES") {
            this.cancellation_fee += this.data.payments[i].amount;
          }
        }
      }
      if (this.data.dynamic_constraints && this.data.dynamic_constraints.length != 0) {
        for (let i = 0; i < this.data.dynamic_constraints.length; i++) {
          if (this.data.dynamic_constraints[i].constraint_name == "Pets") {
            this.constraints.push({
              title: this.data.dynamic_constraints[i].Abbreviation,
              icon: "animal",
              strike_through: this.data.dynamic_constraints[i].strike_through
            });
          } else if (this.data.dynamic_constraints[i].constraint_name == "Wheelchair") {
            this.constraints.push({
              title: this.data.dynamic_constraints[i].Abbreviation,
              icon: "wheelchair",
              strike_through: this.data.dynamic_constraints[i].strike_through
            });
          } else if (this.data.dynamic_constraints[i].constraint_name == "Amex") {
            this.constraints.push({
              title: this.data.dynamic_constraints[i].Abbreviation,
              icon: "amex",
              strike_through: this.data.dynamic_constraints[i].strike_through
            });
          } else if (this.data.dynamic_constraints[i].constraint_name == "Low car") {
            this.constraints.push({
              title: this.data.dynamic_constraints[i].Abbreviation,
              icon: "low_car",
              strike_through: this.data.dynamic_constraints[i].strike_through
            });
          } else if (this.data.dynamic_constraints[i].constraint_name == "mad") {
            this.constraints.push({
              title: this.data.dynamic_constraints[i].Abbreviation,
              icon: "mad",
              strike_through: this.data.dynamic_constraints[i].strike_through
            });
          } else {
            this.constraints.push({
              title: this.data.dynamic_constraints[i].Abbreviation,
              icon: false,
              strike_through: this.data.dynamic_constraints[i].strike_through
            });
          }
        }
        // this.constraints.push({
        //   title: "AA",
        // });
      }
      // if (this.data.pets) {
      //   this.constraints.push({
      //     title: "Pets",
      //     icon: "animal",
      //   });
      // }
      // if (this.data.wheelchair) {
      //   this.constraints.push({
      //     title: "Wheelchair",
      //     icon: "wheelchair",
      //   });
      // }
      // if (this.data.amex) {
      //   this.constraints.push({
      //     title: "Amex",
      //     icon: "amex",
      //   });
      // }
      // if (this.data.encompt) {
      //   this.constraints.push({
      //     title: "Encompt",
      //     icon: "en_compt",
      //   });
      // }
      // if (this.data.low_car) {
      //   this.constraints.push({
      //     title: "Low car",
      //     icon: "low_car",
      //   });
      // }
      // if (this.data.mad) {
      //   this.constraints.push({
      //     title: "mad",
      //     icon: "mad",
      //   });
      // }
      // if (this.data.test) {
      //   this.constraints.push({
      //     title: "test",
      //     icon: "test",
      //   });
      // }
    }
  },
  methods: {
    validateEmail(email) {
      let res = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      return res.test(email);
    },
    formateDateTime(time) {
      return moment(time).format("HH[h]m - DD[/]MM[/]YYYY");
    },
    pastTime(time) {
      moment.locale("fr");
      return moment(time).fromNow();
    },
    stringToColour(str) {
      var hash = 0;
      for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      var colour = "#";
      for (var i = 0; i < 3; i++) {
        var value = (hash >> (i * 8)) & 0xff;
        colour += ("00" + value.toString(16)).substr(-2);
      }
      return colour;
    },
  },
};
</script>

<style lang="scss" scoped>
.timer {
  color: red;
  font-weight: bold;
}

.strike_through {
  text-decoration-line: line-through
}

.container {
  /*w-full h-auto float-left rounded-lg bg-white px-5 py-4 shadow*/
  width: 100%;
  height: auto;
  float: left;
  margin: 0;
  border-radius: 8px;
  background: white;
  padding: 1rem 1.25rem;
  box-shadow: 0px 0px 6px rgba($color: #000000, $alpha: 0.08);

  &.priority-border {
    box-shadow: inset 0px 0px 0px 1px gold, 0px 0px 6px rgba($color: gold, $alpha: 0.08);
  }

  p {
    margin: 0px;
  }

  .content {
    /*w-full float-left flex flex-col gap-5 font-medium*/
    width: 100%;
    float: left;
    display: flex;
    flex-direction: column;
    gap: 0.85rem;
    font-weight: 500;

    /*w-full float-left*/
    .title {
      width: 100%;
      float: left;
      line-height: auto !important;
      font-family: Poppins !important;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .info {
        float: left;
        color: #222629;
        background: transparent !important;
        font-size: 14px;
        font-weight: normal;
        width: 100%;
        position: relative;

        .order-id {
          // width: 100%;
          float: left;
          display: flex;
          flex-wrap: wrap;
          width: 80%;
          align-items: center;

          p {
            width: 100%;
            float: left;
          }

          span {
            margin: 0 2%;
          }
        }
      }

      .constraints {
        float: right;
        height: auto;
        display: flex;
        flex-direction: row;
        gap: 7px;

        img {
          float: right;
        }
      }
    }

    .locations {
      width: 100%;
      float: left;
      height: auto;
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      flex-wrap: wrap;
      gap: 12px;

      // w-full flex flex-row items-center
      .location {
        // width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        float: left;

        .circle {
          border-radius: 100%;
          width: 15px;
          min-width: 15px;
          height: 15px;
          min-height: 15px;
          float: left;
          background: #e10015;
          border: 3px solid #e10015;
        }

        label {
          margin-left: 4px;
          float: left;
          word-break: break-word;
        }
      }
    }

    /*w-full float-left text-sm text-gray*/
    .datetime {
      width: 100%;
      float: left;
      font-size: 14px;
      color: #788e98;
      font-weight: 400;
    }

    // w-full float-left flex flex-row items-center gap-2
    .driver {
      width: 100%;
      float: left;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 0.4rem;

      .captain-profile-pic {
        max-height: 24px;
        padding: 2px 8px;
        background-color: #e1e1e1;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 99px;
      }


      // rounded-full overflow-hidden img-shadow
      img {
        border-radius: 100%;
        overflow: hidden;
      }
    }
  }
}
</style>
